import { useQuery } from '@tanstack/react-query';
import { fetchDashboardMetrics } from '@/services/platform-admin-api';

const PLATFORM_DASHBOARD_KEY = ['platform', 'dashboard'];

export function usePlatformDashboard() {
  return useQuery({
    queryKey: PLATFORM_DASHBOARD_KEY,
    queryFn: fetchDashboardMetrics,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
